export default __webpack_public_path__ + "static/carpet-d5693d37c04a91336670e5fdb5088679.png";